<template>
    <div class="resultados" id="resultados">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center resultados__header wow animate__animated animate__fadeInUp">
                    <div class="resultados__label">
                        <span class="resultados__label-line"></span>
                        <span class="resultados__label-text">Resultados</span>
                        <span class="resultados__label-line"></span>
                    </div>
                    <h2 class="resultados__title">
                        Transformações que<br>
                        <em>falam por si</em>
                    </h2>
                    <p class="resultados__desc">
                        As facetas de resina composta são indicadas para melhorar cor, formato e posição do dente
                    </p>
                </div>
            </div>
            <div class="row align-items-center mt-5">
                <div
                    class="col-12 col-lg-5 wow animate__animated animate__fadeInLeft"
                >
                    <div class="resultados__carousel">
                        <VueSlickCarousel v-bind="settings">
                            <div v-for="n in 12" :key="n" class="resultados__slide">
                                <img
                                    :src="getImage(n)"
                                    class="resultados__slide-img"
                                />
                            </div>
                        </VueSlickCarousel>
                    </div>
                </div>
                <div class="col-12 col-lg-6 offset-lg-1 wow animate__animated animate__fadeInRight">
                    <div class="resultados__video">
                        <video width="100%" controls>
                            <source
                                src="@/assets/img/video-2.mp4"
                                type="video/mp4"
                            />
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    name: "Modelos",
    components: { VueSlickCarousel },
    data() {
        return {
            settings: {
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnDotsHover: true,
                pauseOnFocus: true,
                pauseOnHover: true,
                fade: true,
            },
        };
    },
    methods: {
        getImage(n) {
            const images = require.context('@/assets/img/', false, /\.(jpg)$/);
            const mapping = [12, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 1];
            return images(`./${mapping[n - 1]}.jpg`);
        }
    }
};
</script>

<style src="./style.scss" lang="scss" scoped/>
